module.exports = __webpack_public_path__ + "static/img/background.4d05c79b.svg";